import Serializer, { extractCardImage } from './Serializer.js'
import { PLATFORM_FILTERS_TO_HIDE } from '@config/options.js'
import { PLATFORM_OPTION } from '@composables/useFilter.js'
import { clone, isObj } from '@helpers/utils.js'
import { HEADERS } from '@config/game.js'

const transformations = [
  transformTags,
  extractCardImage(''),
  _UGCSingle,
  _generatePlatformFilters,
]

const gameSerializer = new Serializer({
  transformations,
})

function _UGCSingle(game) {
  game.ugc_name = game.ugc_name || 'Mods'
  game.ugc_name_single = game.ugc_name.replace(/s$/, '')
  return game
}

function transformTags(game) {
  const gameCopy = clone(game)
  if (gameCopy.tag_options) {
    gameCopy.tag_options = _setTagIds(gameCopy.tag_options)
  }

  return gameCopy
}

function _setTagIds(tags) {
  tags.forEach((tag, index) => {
    tag.id = `T-${index}`
    tag.selected = []
    // Handle cases where tags are saved as an object in API
    tag.tags = isObj(tag.tags) ? Object.values(tag.tags) : tag.tags
  })
  return tags
}

function _generatePlatformFilters(game) {
  if (HEADERS.platform) return game

  game.tag_options = game.tag_options || []

  if (game.platforms?.length) {
    game.tag_options = [
      {
        id: PLATFORM_OPTION.replace(' ', '-'),
        name: PLATFORM_OPTION,
        tags: game.platforms
          .filter((p) => !PLATFORM_FILTERS_TO_HIDE.includes(p.platform))
          .map((platformObj) => platformObj.label),
        type: 'dropdown',
        selected: [],
      },
      ...game.tag_options.filter((option) => option.name !== PLATFORM_OPTION),
    ]
  }
  return game
}

export default gameSerializer
